





























































































import { Component, Vue, Prop, Watch } from "vue-property-decorator";
import KepatuhanJatuhStore from "@/store/modules/KepatuhanJatuhStore";

@Component
export default class RekapPeriodikStep extends Vue {
  @Prop({ default: null }) session!: any;
  msg = "";
  err = "";
  loading = false;
  result: any = null;

  periode: "bulanan" | "triwulanan" | "semester" = "bulanan";
  tahun = new Date().getFullYear();
  bulan: number = new Date().getMonth() + 1;
  triwulan = 1;
  semester = 1;

  periodeOpts = [
    { text: "Bulanan", value: "bulanan" },
    { text: "Triwulanan", value: "triwulanan" },
    { text: "Semester", value: "semester" }
  ];

  bulanOpts = [
    { text: "Januari", value: 1 },
    { text: "Februari", value: 2 },
    { text: "Maret", value: 3 },
    { text: "April", value: 4 },
    { text: "Mei", value: 5 },
    { text: "Juni", value: 6 },
    { text: "Juli", value: 7 },
    { text: "Agustus", value: 8 },
    { text: "September", value: 9 },
    { text: "Oktober", value: 10 },
    { text: "November", value: 11 },
    { text: "Desember", value: 12 }
  ];

  get store() {
    return KepatuhanJatuhStore;
  }

  get tahunOpts() {
    const now = new Date().getFullYear();
    return [now, now - 1, now - 2];
  }

  get rekapSummary() {
    if (!this.result) return {};
    const { numerator, denominator, pct, jumlah_sesi, kategori_kepatuhan } =
      this.result as any;
    return {
      Numerator: numerator ?? "-",
      Denominator: denominator ?? "-",
      "Capaian (%)": pct != null ? Number(pct).toFixed(2) : "-",
      "Jumlah Sesi": jumlah_sesi ?? "-",
      Kategori: kategori_kepatuhan ?? "-"
    };
  }

  @Watch("session", { immediate: true, deep: true })
  onSession(v: any) {
    if (!v) return;
    if (v.periode_tahun) this.tahun = v.periode_tahun;
    if (v.periode_bulan) this.bulan = v.periode_bulan;
    else if (v.tanggal_observasi) {
      this.bulan = new Date(v.tanggal_observasi).getMonth() + 1;
    }
  }

  async generate() {
    this.loading = true;
    this.msg = "";
    this.err = "";
    this.result = null;
    try {
      const payload: any = { periode: this.periode, tahun: this.tahun };
      if (this.periode === "bulanan") payload.bulan = this.bulan;
      if (this.periode === "triwulanan") payload.triwulan = this.triwulan;
      if (this.periode === "semester") payload.semester = this.semester;

      const data = await this.store.generateRekap(payload);
      this.result = data || null;
      this.msg = `Rekap ${this.periode} berhasil di-generate.`;
    } catch (e) {
      this.err = e.response?.data?.message || e.message || "Gagal generate rekap";
    } finally {
      this.loading = false;
    }
  }
}
